import React, { useContext, useEffect } from 'react';
import CashZoneButton from '../CashZoneButton';
import LoginContext from '../../context';
import CashButton from '../CashButton';
import CashEventRadioButton from '../CashEventRadioButton';

const CashZoneComponent = ({ handleAmountClick, amount, setAmount, handleDepositRequest, name, setName, events }) => {
  const { user } = useContext(LoginContext);
  useEffect(() => {
    setName(user?.username);
  }, [user, setName]);

  return (
    <>
      <div className="">
        <table
          width="100%"
          cellspacing="0"
          cellpadding="0"
          className="border-b-none border border-slate bg-charcoal text-xs text-white font-Serif"
        >
          <tbody>
            <tr>
              <th className="text-white p-2.5 lg:py-0 lg:px-2.5 bg-graphite border-r-slate border-b-slate border-b border-r">
                입금하실계좌
              </th>
              <td align="left" className="p-2.5 border-b-slate border-b">
                <span id="btnSubmitZone">
                  <input
                    type="button"
                    value="입금계좌요청"
                    className="cursor-pointer text-sm font-bold h-[38px] leading-[38px] hidden lg:inline-block align-middle rounded text-white transition-[0.2s] shadow-[inset_0_1px_0px_0_rgba(255,255,255,0.3)] m-px px-5 border-none bg-deep-blue hover:filter hover:brightness-[1.23]"
                  />
                  <input
                    type="button"
                    value="고객센터문의"
                    className="cursor-pointer text-sm font-bold h-[38px] leading-[38px] inline-block lg:hidden align-middle text-white transition-[0.2s] m-px px-5 border-none bg-[#14b320] "
                  />
                </span>
              </td>
            </tr>
            <tr>
              <th className="text-white p-2.5 lg:py-0 lg:px-2.5 bg-graphite border-r-slate border-b-slate border-b border-r">
                포인트선택
              </th>
              <td className="leading-[19px] lg:leading-[25px] p-2.5 border-b-slate border-b">
                {/* 
                    서버에서 받아온 이벤트 렌더링
                */}
                <CashEventRadioButton events={events} />

                <span className="text-sm text-[#f00]">
                  <span className="text-[#ffff48]">
                    ※무한 첫&amp;매충 이벤트{' '}
                    <span className="text-crimson">보너스 지급시 규정위반 사례가 여러차례 확인되고 있사오니</span>{' '}
                    <span className="text-[#ffff48]">주의 부탁드립니다^^! ※</span>
                  </span>
                </span>
              </td>
            </tr>
            <tr>
              <th className="text-white p-2.5 lg:py-0 lg:px-2.5 bg-graphite border-r-slate border-b-slate border-b border-r">
                충전금액
              </th>
              <td align="left" className="p-2.5 border-b-slate border-b">
                <input
                  name="point"
                  type="text"
                  className="max-w-[187px] w-full font-NotoSansKR border bg-obsidian text-white text-xs leading-[36px] lg:leading-[39px] h-[36px] lg:h-[39px] transition-[0.2s] align-middle px-[5px] py-0.5 pe-[5px] text-right lg:rounded-[5px] border-slate me-1 outline-none lg:focus:border-indigoBlue focus:border-[#ffcc00]"
                  size="25"
                  value={amount.toLocaleString()}
                  onChange={(e) => {
                    const cleaned = e.target.value.replace(/[^0-9]/g, '');
                    setAmount(Number(cleaned));
                  }}
                />
                원 &nbsp;&nbsp; &nbsp;&nbsp;
                <div className="hidden lg:inline">
                  <CashZoneButton
                    label="1만원"
                    value={10000}
                    onClick={() => handleAmountClick('1만원', 10000)}
                    link_src="#"
                    active_color="bg-amberGold"
                    active={false}
                    type="button"
                  />
                  <CashZoneButton
                    label="3만원"
                    value={30000}
                    onClick={() => handleAmountClick('3만원', 30000)}
                    link_src="#"
                    active_color="bg-amberGold"
                    active={false}
                    type="button"
                  />
                  <CashZoneButton
                    label="5만원"
                    value={50000}
                    onClick={() => handleAmountClick('5만원', 50000)}
                    link_src="#"
                    active_color="bg-amberGold"
                    active={false}
                    type="button"
                  />
                  <CashZoneButton
                    label="10만원"
                    value={100000}
                    onClick={() => handleAmountClick('10만원', 100000)}
                    link_src="#"
                    active_color="bg-amberGold"
                    active={false}
                    type="button"
                  />
                  <CashZoneButton
                    label="50만원"
                    value={500000}
                    onClick={() => handleAmountClick('50만원', 500000)}
                    link_src="#"
                    active_color="bg-amberGold"
                    active={false}
                    type="button"
                  />
                  <CashZoneButton
                    label="100만원"
                    value={1000000}
                    onClick={() => handleAmountClick('100만원', 1000000)}
                    link_src="#"
                    active_color="bg-amberGold"
                    active={false}
                    type="button"
                  />
                  <CashZoneButton
                    label="300만원"
                    value={2000000}
                    onClick={() => handleAmountClick('300만원', 3000000)}
                    link_src="#"
                    active_color="bg-amberGold"
                    active={false}
                    type="button"
                  />
                  <CashZoneButton
                    label="500만원"
                    value={5000000}
                    onClick={() => handleAmountClick('500만원', 5000000)}
                    link_src="#"
                    active_color="bg-amberGold"
                    active={false}
                    type="button"
                  />
                  <CashZoneButton
                    label="1000만원"
                    value={10000000}
                    onClick={() => handleAmountClick('1000만원', 10000000)}
                    link_src="#"
                    active_color="bg-amberGold"
                    active={false}
                    type="button"
                  />
                  <CashZoneButton
                    label="정정"
                    value={0}
                    onClick={() => handleAmountClick('정정', 0)}
                    link_src="#"
                    active_color="bg-amberGold"
                    active={true}
                    type="button"
                  />
                </div>
              </td>
            </tr>
            <tr className="lg:hidden">
              <td align="left" className="p-2.5 border-b-slate border-b font-sans-serif" colSpan="2">
                <CashZoneButton
                  label="1만원"
                  value={10000}
                  onClick={() => handleAmountClick('1만원', 10000)}
                  link_src="#"
                  active_color="bg-amberGold"
                  active={false}
                  type="button"
                />
                <CashZoneButton
                  label="3만원"
                  value={30000}
                  onClick={() => handleAmountClick('3만원', 30000)}
                  link_src="#"
                  active_color="bg-amberGold"
                  active={false}
                  type="button"
                />
                <CashZoneButton
                  label="5만원"
                  value={50000}
                  onClick={() => handleAmountClick('5만원', 50000)}
                  link_src="#"
                  active_color="bg-amberGold"
                  active={false}
                  type="button"
                />
                <CashZoneButton
                  label="10만원"
                  value={100000}
                  onClick={() => handleAmountClick('10만원', 100000)}
                  link_src="#"
                  active_color="bg-amberGold"
                  active={false}
                  type="button"
                />
                <CashZoneButton
                  label="50만원"
                  value={500000}
                  onClick={() => handleAmountClick('50만원', 500000)}
                  link_src="#"
                  active_color="bg-amberGold"
                  active={false}
                  type="button"
                />
                <CashZoneButton
                  label="100만원"
                  value={1000000}
                  onClick={() => handleAmountClick('100만원', 1000000)}
                  link_src="#"
                  active_color="bg-amberGold"
                  active={false}
                  type="button"
                />
                <CashZoneButton
                  label="300만원"
                  value={2000000}
                  onClick={() => handleAmountClick('300만원', 3000000)}
                  link_src="#"
                  active_color="bg-amberGold"
                  active={false}
                  type="button"
                />
                <CashZoneButton
                  label="500만원"
                  value={5000000}
                  onClick={() => handleAmountClick('500만원', 5000000)}
                  link_src="#"
                  active_color="bg-amberGold"
                  active={false}
                  type="button"
                />
                <CashZoneButton
                  label="1000만원"
                  value={10000000}
                  onClick={() => handleAmountClick('1000만원', 10000000)}
                  link_src="#"
                  active_color="bg-amberGold"
                  active={false}
                  type="button"
                />
                <CashZoneButton
                  label="정정"
                  value={0}
                  onClick={() => handleAmountClick('정정', 0)}
                  link_src="#"
                  active_color="bg-amberGold"
                  active={true}
                  type="button"
                />
              </td>
            </tr>
            <tr>
              <th className="text-white p-2.5 lg:py-0 lg:px-2.5 bg-graphite border-r-slate border-b-slate border-b border-r">
                입금자명
              </th>
              <td align="left" className="p-2.5 border-b-slate border-b">
                {name}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <CashButton onClick={handleDepositRequest} label="충전신청" />
    </>
  );
};

export default CashZoneComponent;
